import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, logout } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);

            const userCredential = await login(email, password);

            // Verify user has a valid role
            const tokenResult = await userCredential.user.getIdTokenResult();
            const role = tokenResult.claims.role;
            const isAdmin = tokenResult.claims.admin;

            if (!isAdmin && !['editor', 'viewer'].includes(role)) {
                await logout();
                setError('Acesso negado. Você não tem permissão para acessar este painel.');
                setLoading(false);
                return;
            }

            navigate('/');
        } catch (error) {
            console.error('Login error:', error);
            setError('Falha ao fazer login. Verifique suas credenciais.');
        }

        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div style={{
                        fontSize: '3.2rem',
                        fontWeight: '900',
                        color: '#12a046',
                        letterSpacing: '-2px',
                        marginBottom: '8px',
                        lineHeight: '1'
                    }}>
                        Otyma<span style={{ color: '#111827' }}>Farma</span>
                    </div>
                    <p>Portal Administrativo</p>
                </div>

                {error && (
                    <div className="error-message">
                        <i className="fas fa-exclamation-circle"></i>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">
                            <i className="fas fa-envelope"></i> Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="seu@email.com"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">
                            <i className="fas fa-lock"></i> Senha
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="••••••••"
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn-login"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <i className="fas fa-spinner fa-spin"></i> Entrando...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-sign-in-alt"></i> Entrar
                            </>
                        )}
                    </button>
                </form>

                <div className="login-footer">
                    <p style={{ color: '#999', fontSize: '0.85rem' }}>
                        Acesso restrito a administradores
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
